/**
 * Configuración modular de exploradores/dApps.
 * Para añadir uno nuevo, solo agrega una entrada a este arreglo.
 */

export interface ExplorerEntry {
  id: string
  name: string
  descriptionKey: string // clave i18n, ver src/locales/*/translation.json -> explorer.items
  url: string
  logoUrl?: string // si se omite, se usa el ícono genérico de respaldo
}

// Placeholders hasta que existan URLs reales para estos sitios propios del ecosistema OMD.
const OMM_URL = import.meta.env.VITE_OMM_URL || 'https://onemillionminers.com/'
const OMD_DEX_URL =
  import.meta.env.VITE_OMD_DEX_URL || 'https://test.omdbswap.finance/'

export const EXPLORERS: ExplorerEntry[] = [
  {
    id: 'omm',
    name: 'OneMillionMiners',
    descriptionKey: 'explorer.items.omm.description',
    url: OMM_URL,
    logoUrl: '/assets/omm.svg'
  },
  {
    id: 'omd-dex',
    name: 'OMDBSWAP',
    descriptionKey: 'explorer.items.omd_dex.description',
    url: OMD_DEX_URL,
    logoUrl: '/assets/omdbswap.png'
  },
  {
    id: 'pancakeswap',
    name: 'PancakeSwap',
    descriptionKey: 'explorer.items.pancakeswap.description',
    url: 'https://pancakeswap.finance',
    logoUrl: '/assets/panckakeswap.png'
  },
  {
    id: 'uniswap',
    name: 'Uniswap',
    descriptionKey: 'explorer.items.uniswap.description',
    url: 'https://app.uniswap.org',
    logoUrl: '/assets/uniswap.png'
  },
  {
    id: 'dextools',
    name: 'DEX Tools',
    descriptionKey: 'explorer.items.dextools.description',
    url: 'https://www.dextools.io',
    logoUrl: '/assets/dextools.png'
  }
]
